import { Component, OnInit, ViewChild } from '@angular/core';

import { HeaderComponent } from '../core/navigation/header/header.component';
import { ActivatedRoute } from '@angular/router';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'postd-info-pages',
  templateUrl: './info-pages.component.html',
  styleUrls: ['./info-pages.component.scss']
})
export class InfoPagesComponent {
  @ViewChild(HeaderComponent) perplayHeaderComponent: HeaderComponent;
  hideSidebar = of(false);

  constructor(route: ActivatedRoute) {
    if (route.children.length > 0) {
      this.hideSidebar = route.children[0].data.pipe(
        map(data => data.hideSidebar as boolean)
      );
    }
  }

  activateChild(componentRef) {
    if (typeof componentRef.registerParent === 'function') {
      componentRef.registerParent(this);
    }
  }

  signin() {
    console.log('signin');
    this.perplayHeaderComponent.onSigninClick(true);
  }
}
